import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../Store';

export default function UserManagerRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  // Admins and User Managers always pass. A plain staff member explicitly
  // granted canManageStaff also gets in — they can view the roster and open
  // the role editor, but the destructive user actions stay hidden for them
  // (see UserListScreen). Every endpoint re-checks server-side regardless.
  const allowed =
    userInfo &&
    (userInfo.isAdmin ||
      userInfo.isUserManager ||
      userInfo.permissions?.canManageStaff);
  return allowed ? children : <Navigate to="/signin" />;
}
